import { combineEpics, ofType } from 'redux-observable';
import {
  filter, flatMap,
  pluck,
} from 'rxjs/operators';

import { actions as bootstrapActions } from '@ezugi/bootstrap';
import {
  CANCEL_LAST_CARD,
  CANCEL_ROUND,
  CARD,
  GAME_RESULT,
  INITIAL_DATA,
  NO_MORE_BETS,
  PLACE_YOUR_BETS,
  SKIP_PYB_TIMER,
  WON_BETS,
} from '@ezugi/constants';

import { isBackAndLaySelector } from '../../selectors/game';
import handleBLWonBets from '../BackAndLay/socket/handleBLWonBets';
import handleCancelLastCard from './handleCancelLastCard';
import handleCancelRound from './handleCancelRound';
import handleCardMessage from './handleCardMessage';
import handleGameResult from './handleGameResult';
import handleInitialData from './handleInitialData';
import handleNoMoreBets from './handleNoMoreBets';
import handlePlaceYourBets from './handlePlaceYourBets';
import handleSkipPYBTimer from './handleSkipPYBTimer';
import handleWonBets from './handleWonBets';

/* BACK & LAY */

const { socketActions: { socket } } = bootstrapActions;

function initialDataEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType }) => MessageType === INITIAL_DATA),
    flatMap((socketMessage) => handleInitialData(socketMessage, state$.value))
  );
}

function placeYourBetsEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType }) => MessageType === PLACE_YOUR_BETS),
    flatMap((socketMessage) => handlePlaceYourBets(socketMessage, state$.value))
  );
}

function noMoreBetsEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType }) => MessageType === NO_MORE_BETS),
    flatMap((socketMessage) => handleNoMoreBets(socketMessage, state$.value))
  );
}

function gameResultEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType }) => MessageType === GAME_RESULT),
    flatMap((socketMessage) => handleGameResult(socketMessage, state$.value))
  );
}

function cardMessageEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType }) => MessageType === CARD),
    flatMap((socketMessage) => handleCardMessage(socketMessage, state$.value))
  );
}

function cancelLastCardEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType }) => MessageType === CANCEL_LAST_CARD),
    flatMap((socketMessage) => handleCancelLastCard(socketMessage, state$.value))
  );
}

function cancelRoundEpic(action$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType }) => MessageType === CANCEL_ROUND),
    flatMap(handleCancelRound)
  );
}

function wonBetsEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType }) => MessageType === WON_BETS),
    flatMap((socketMessage) => (isBackAndLaySelector(state$.value)
      ? handleBLWonBets(socketMessage, state$.value) : handleWonBets(socketMessage, state$.value)
    ))
  );
}

function skipPYBTimerEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType }) => MessageType === SKIP_PYB_TIMER),
    flatMap((socketMessage) => handleSkipPYBTimer(socketMessage, state$.value))
  );
}

export default combineEpics(
  gameResultEpic,
  cardMessageEpic,
  cancelLastCardEpic,
  cancelRoundEpic,
  initialDataEpic,
  wonBetsEpic,
  placeYourBetsEpic,
  noMoreBetsEpic,
  skipPYBTimerEpic,
);
